/**
 * Хранилище модуля PageRegularDelivery
 * @module PageRegularDelivery/Store
 * @requires Vue
 * @requires Vuex
 * */

import Vue from 'vue'
import Vuex from 'vuex'
import * as api from 'API/shops'
import { isUndefined } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    stores: [],
    page: 1,
    elementsPerPage: 10,
    totalAmount: 0,
    groupBy: ''
  }),
  getters: {
    deserializeShop: () => (shop) => ({
      ...shop,
      latitude: shop.coordinates?.x || '',
      longitude: shop.coordinates?.y || ''
    })
  },
  actions: {
    async getStores({
      state, commit, dispatch, getters
    }, params = {}) {
      const sortBy = {
        column: params.orderBy || '',
        direction: params.sortDirection || ''
      }

      const requestParams = {
        page: params.page || 1,
        items_on_page: state.elementsPerPage,
        filters: params.filters,
        group_by: state.groupBy || null,
        sort_by: Object.entries(sortBy).some(keyVal => !!keyVal[1]) ? sortBy : undefined
      }

      const { data } = await api.getShops(requestParams)

      let shops = []

      // Проверяем есть ли элементы на запрошенной странице, если нет, запросим первую
      if (
        ((requestParams.group_by && data.indexes.length === 0)
          || (!requestParams.group_by && (data.data?.length === 0 || isUndefined(data.data))))
        && requestParams.page > 1) {
        requestParams.page = 1
        dispatch('getStores', requestParams)
        return false
      }

      if (requestParams.group_by) {
        shops = data.indexes.map(index => ({
          [index.column]: index.value || '',
          children: index.collection_indexes
            .map(collectionIndex => getters.deserializeShop(data.data[collectionIndex]))
        })) || []
      } else {
        shops = data.map(getters.deserializeShop) || []
      }
      commit('updateStores', shops)
      commit('updatePage', requestParams.page)
      commit('updateTotalAmount', data.count)
      return true
    },
    toggleGroupByRegion({ state, commit, dispatch }) {
      commit('setGroupBy', state.groupBy === 'region' ? '' : 'region')
      dispatch('getStores')
    }
  },
  mutations: {
    updateStores(state, stores) {
      state.stores = stores
    },
    updatePage(state, page) {
      state.page = page
    },
    updateTotalAmount(state, totalAmount) {
      state.totalAmount = totalAmount
    },
    setGroupBy(state, group) {
      state.groupBy = group
    }
  }
})
